import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import { userService } from 'src/services/user.service'

export const useSetUserWlp = () => {
  const queryClient = useQueryClient()
  return useMutation((dataToSend:any) =>{
    const data = {userId: dataToSend.userId, wlpId: dataToSend.wlpId}
    return  userService.setUserWlp(data)
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.USER])
    },
  })
}
